import React from 'react';

const About: React.FC = () => (
  <div className="max-w-3xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
    <h1 className="text-3xl font-bold mb-6 text-center">About WeTrackSSL</h1>
    <div className="bg-white rounded-xl shadow p-6 text-lg text-gray-800">
      <p className="mb-4">
        <strong>WeTrackSSL</strong> is a modern web application designed to help individuals and organizations never miss an SSL certificate expiration again. Our platform provides comprehensive monitoring for both public and private SSL certificates, ensuring your domains and infrastructure remain secure and trusted.
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li>Monitor all your SSL certificates in one simple dashboard.</li>
        <li>Receive timely notifications via email, SMS, Slack, or Microsoft Teams before certificates expire.</li>
        <li>Easy setup for both public and internal/private certificates.</li>
        <li>Security-first: all sensitive data is encrypted and securely stored.</li>
        <li>Regular security audits and best practices to keep your data safe.</li>
      </ul>
      <p>
        WeTrackSSL was built to solve the real-world problem of unexpected certificate expirations, which can lead to outages, security warnings, and loss of trust. Our mission is to make SSL management effortless and reliable for everyone.
      </p>
    </div>
  </div>
);

export default About;
